import { render, staticRenderFns } from "./LastPlayersSearch.vue?vue&type=template&id=9b328c4c"
import script from "./LastPlayersSearch.vue?vue&type=script&lang=js"
export * from "./LastPlayersSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports